/**
 * LockedSection.jsx — Toont content locked of open afhankelijk van plan.
 * Gebruik: <LockedSection isPaid={isPaid} title="..." upgradeText="...">...</LockedSection>
 */
import React from 'react';
import { Link } from 'react-router-dom';
import { Lock, ArrowRight, Zap } from 'lucide-react';

export default function LockedSection({ isPaid, children, title, upgradeText, compact = false, blur = true }) {
  if (isPaid) return <>{children}</>;

  return (
    <div className="relative overflow-hidden rounded-2xl">
      {/* Blurred content */}
      {blur && (
        <div className="opacity-30 pointer-events-none select-none" style={{ filter: 'blur(4px)' }}>
          {children}
        </div>
      )}

      {/* Lock overlay */}
      <div className={`${blur ? 'absolute inset-0' : ''} flex flex-col items-center justify-center ${compact ? 'p-4' : 'p-8'} bg-white/60 backdrop-blur-[2px] rounded-2xl`}>
        <div className="w-10 h-10 bg-[#D4A017]/10 rounded-full flex items-center justify-center mb-3">
          <Lock className="w-5 h-5 text-[#D4A017]" />
        </div>
        {title && <p className="text-[#0f172a] font-bold text-sm mb-1 text-center">{title}</p>}
        <p className="text-[#64748b] text-xs text-center mb-3 max-w-xs">
          {upgradeText || 'Beschikbaar met IMPERIA AI Radar'}
        </p>
        <Link to="/radar"
          className="inline-flex items-center gap-1.5 bg-[#D4A017] text-[#0f172a] font-bold text-xs px-4 py-2 rounded-lg hover:bg-[#B8860B] transition-all">
          <Zap size={12} /> Upgraden — €14,95 excl. btw
        </Link>
      </div>
    </div>
  );
}
